var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventChangeRequired = function SvgEventChangeRequired(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1356_32272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6366 3.34355L2.36598 25.9683C2.12627 26.3769 2.00004 26.8404 2 27.3122C1.99996 27.784 2.12609 28.2475 2.36573 28.6561C2.60537 29.0648 2.95006 29.4041 3.36516 29.64C3.78025 29.8759 4.25112 30 4.73042 30H31.2696C31.7489 30 32.2197 29.8759 32.6348 29.64C33.0499 29.4041 33.3946 29.0648 33.6343 28.6561C33.8739 28.2475 34 27.784 34 27.3122C34 26.8404 33.8737 26.3769 33.634 25.9683L20.3648 3.34355C20.1252 2.93506 19.7806 2.59584 19.3656 2.36C18.9506 2.12416 18.4799 2 18.0007 2C17.5215 2 17.0508 2.12416 16.6358 2.36C16.2208 2.59584 15.8762 2.93506 15.6366 3.34355Z",
    fill: "#FF535F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8601 10.0039H17.5193C16.6802 10.0039 16 10.7326 16 11.6315V19.411C16 20.3099 16.6802 21.0386 17.5193 21.0386H17.8601C18.6991 21.0386 19.3793 20.3099 19.3793 19.411V11.6315C19.3793 10.7326 18.6991 10.0039 17.8601 10.0039Z",
    fill: "#FFF7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6897 27.2101C18.6228 27.2101 19.3793 26.3997 19.3793 25.4C19.3793 24.4003 18.6228 23.5898 17.6897 23.5898C16.7565 23.5898 16 24.4003 16 25.4C16 26.3997 16.7565 27.2101 17.6897 27.2101Z",
    fill: "#FFF7ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1356_32272",
    x: 0,
    y: 0,
    width: 36,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1356_32272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1356_32272",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventChangeRequired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eventChangeRequired.c68599a2776cea962d2685cb8816179f.svg";